/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useCallback } from 'react';
import DataTable from 'react-data-table-component';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import moment from 'moment';
import api from 'api';
import { toast } from 'react-toastify';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { Header, SideMenu, Search, Button, Dialog, UploadFileInput } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea, ModalButton } from './styles';
import { loadingColor, primary, secondary, white, lightGray, middleGray } from 'styles/colorProvider';
import {
  BsDownload,
  BsUpload,
  BsShieldCheck,
  BsArrowClockwise,
  BsCheck2Circle,
  BsXCircle,
  BsReceipt,
  BsClipboard,
} from 'react-icons/bs';
import {
  REACTIVATION_STATUS,
  REACTIVATION_NEXT_STEP,
  REACTIVATION_ENDPOINTS,
  REACTIVATION_UPLOADED_DOCUMENT_TYPE,
  dataColumns,
  normalizeMovements,
  getStatusLabel,
  getMovementDateValue,
  formatPolicyReactivationStatus,
  getReactivationCurrentStatus,
  reactivationStatusEquals,
  isReactivationInspectApprovedStep,
  parseReactivationInspectionLinkResponse,
  getReactivationInspectionDisplayCode,
  getReactivationInspectionLink,
} from './helper';

function PolicyInfoCard({ policy }) {
  if (!policy) return null;
  return (
    <div style={{ border: `1px solid ${lightGray}`, borderRadius: 8, padding: 16, background: '#fafafa' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <BsShieldCheck size={16} color={primary} />
        <span style={{ fontSize: 15, fontWeight: 700, color: primary }}>Contrato {policy?.contrato || '-'}</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 24px', fontSize: 13, color: middleGray }}>
        <span>
          Cliente: <strong style={{ color: '#333' }}>{policy?.cliente || '-'}</strong>
        </span>
        <span>
          CPF: <strong style={{ color: '#333' }}>{policy?.cpf || '-'}</strong>
        </span>
        <span>
          Placa: <strong style={{ color: '#333' }}>{policy?.placa || '-'}</strong>
        </span>
        <span>
          Status:{' '}
          <strong style={{ color: formatPolicyReactivationStatus(policy?.status_reativacao || 'canceled')?.color || '#333' }}>
            {formatPolicyReactivationStatus(policy?.status_reativacao || 'canceled')?.label || '-'}
          </strong>
        </span>
      </div>
    </div>
  );
}

function ReactivationList() {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [policiesList, setPoliciesList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [search, setSearch] = useState('');

  const [loadingAction, setLoadingAction] = useState(false);
  const [loadingCurrentReactivation, setLoadingCurrentReactivation] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [openActionsPanel, setOpenActionsPanel] = useState(false);

  const [openTermPanel, setOpenTermPanel] = useState(false);
  const [signedTermFile, setSignedTermFile] = useState(null);
  const [cnhFile, setCnhFile] = useState(null);

  const [openInspectionPanel, setOpenInspectionPanel] = useState(false);
  const [reactivationDetail, setReactivationDetail] = useState(null);
  /** Link retornado pelo GET /contracts/:id/reactivation/inspection */
  const [inspectionEndpointLink, setInspectionEndpointLink] = useState('');
  const [loadingInspectionEndpointLink, setLoadingInspectionEndpointLink] = useState(false);

  const [openAcceptancePanel, setOpenAcceptancePanel] = useState(false);

  const [openReactivationPaymentPanel, setOpenReactivationPaymentPanel] = useState(false);

  const [openInspectApprovedPanel, setOpenInspectApprovedPanel] = useState(false);
  const [inspectApprovedUrl, setInspectApprovedUrl] = useState('');
  const [loadingInspectApprovedUrl, setLoadingInspectApprovedUrl] = useState(false);

  const [openMovementsPanel, setOpenMovementsPanel] = useState(false);
  const [selectedPolicyMovements, setSelectedPolicyMovements] = useState(null);
  const [loadingMovements, setLoadingMovements] = useState(false);
  const [reactivationHistory, setReactivationHistory] = useState([]);

  const fetchReactivationInspectionUrl = useCallback(async (contractId) => {
    if (!contractId) return '';
    try {
      const resp = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.requestReactivationInspection(contractId),
        headers: {
          Authorization: Cookies.get('splitrisk-authtoken'),
          Accept: 'application/json',
        },
      });
      const raw = resp?.data;
      let url = parseReactivationInspectionLinkResponse(raw);
      if (!url && raw != null && typeof raw === 'object' && raw.data !== undefined && raw.data !== raw) {
        url = parseReactivationInspectionLinkResponse(raw.data);
      }
      return url;
    } catch {
      return '';
    }
  }, []);

  useEffect(() => {
    if (!openInspectionPanel || !selectedPolicy?.id) return undefined;
    let cancelled = false;
    setLoadingInspectionEndpointLink(true);
    setInspectionEndpointLink('');
    fetchReactivationInspectionUrl(selectedPolicy.id).then((url) => {
      if (!cancelled) {
        setInspectionEndpointLink(url);
        setLoadingInspectionEndpointLink(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [openInspectionPanel, selectedPolicy?.id, fetchReactivationInspectionUrl]);

  useEffect(() => {
    if (!openInspectApprovedPanel || !selectedPolicy?.id) return undefined;
    let cancelled = false;
    setLoadingInspectApprovedUrl(true);
    setInspectApprovedUrl('');
    fetchReactivationInspectionUrl(selectedPolicy.id).then((url) => {
      if (!cancelled) {
        setInspectApprovedUrl(url);
        setLoadingInspectApprovedUrl(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [openInspectApprovedPanel, selectedPolicy?.id, fetchReactivationInspectionUrl]);

  const loadData = async ({ silent = false } = {}) => {
    if (!silent) setLoading(true);
    setCurrentPage(1);

    try {
      const resp = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.list,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        params: { search, page: 1, take: 20 },
        json: true,
      });

      const policies = resp?.data?.policies || [];
      setPoliciesList(policies);
      setTotalCount(resp?.data?.totalCount ?? policies.length);
      setHasNextPage(Boolean(resp?.data?.hasNextPage));
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível carregar reativações', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      if (!silent) setLoading(false);
    }
  };

  const handleLoadMore = async () => {
    if (!hasNextPage || loadingMore) return;

    const nextPage = currentPage + 1;
    setLoadingMore(true);

    try {
      const resp = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.list,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        params: { search, page: nextPage, take: 20 },
        json: true,
      });

      const policies = resp?.data?.policies || [];
      setCurrentPage(nextPage);
      setPoliciesList((prev) => prev.concat(policies));
      if (resp?.data?.totalCount != null) {
        setTotalCount(resp.data.totalCount);
      } else {
        setTotalCount((prev) => prev + policies.length);
      }
      setHasNextPage(Boolean(resp?.data?.hasNextPage));
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível carregar mais reativações', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingMore(false);
    }
  };

  const handleExport = async () => {
    setLoadingExport(true);
    try {
      const response = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.export,
        headers: { Authorization: Cookies.get('splitrisk-authtoken') },
        responseType: 'blob',
      });

      const contentDisposition = response?.headers?.['content-disposition'] || '';
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
      const filename = filenameMatch?.[1] || `reativacao_${new Date().toLocaleDateString()}.xlsx`;
      const fileBlob = new Blob([response?.data], {
        type: response?.headers?.['content-type'] || 'application/octet-stream',
      });
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error('Não foi possível exportar reativações', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingExport(false);
    }
  };

  const handleCloseReactivationPaymentPanel = () => {
    setOpenReactivationPaymentPanel(false);
    setSelectedPolicy(null);
  };

  const handleCloseInspectApprovedPanel = () => {
    setOpenInspectApprovedPanel(false);
    setInspectApprovedUrl('');
    setLoadingInspectApprovedUrl(false);
    setSelectedPolicy(null);
  };

  const getInspectApprovedEffectiveLink = () => {
    const fromEndpoint = inspectApprovedUrl?.trim();
    if (fromEndpoint) return fromEndpoint;
    return getReactivationInspectionLink(reactivationDetail)?.trim() || '';
  };

  const handleCopyInspectApprovedLink = async () => {
    const link = getInspectApprovedEffectiveLink();
    if (!link) {
      toast.error('Nenhum link de vistoria disponível.', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      return;
    }
    try {
      await navigator.clipboard.writeText(link);
      toast.success('Link da vistoria copiado!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
    } catch {
      try {
        const ta = document.createElement('textarea');
        ta.value = link;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        toast.success('Link da vistoria copiado!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      } catch {
        toast.error('Não foi possível copiar o link.', {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
        });
      }
    }
  };

  /** POST /contracts/:id/reactivation/confirm — Policies.confirmReactivationPolicy */
  const handleInspectApprovedDecision = async (accepted) => {
    if (!selectedPolicy?.id) return;
    if (!accepted) {
      const ok = window.confirm('Cancelar a confirmação da reativação? O fluxo será encerrado como não concluído.');
      if (!ok) return;
    }
    setLoadingAction(true);
    try {
      await api({
        method: 'POST',
        url: REACTIVATION_ENDPOINTS.confirmReactivation(selectedPolicy.id),
        headers: {
          Authorization: Cookies.get('splitrisk-authtoken'),
          'Content-Type': 'application/json',
        },
        data: { accepted },
      });
      if (accepted) {
        toast.success('Reativação confirmada. Prosseguir para a cobrança.', {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
        });
        setOpenInspectApprovedPanel(false);
        setInspectApprovedUrl('');
        setLoadingInspectApprovedUrl(false);
        setOpenReactivationPaymentPanel(true);
        loadData({ silent: true });
      } else {
        toast.success('Reativação cancelada.', {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
        });
        handleCloseInspectApprovedPanel();
        loadData({ silent: true });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível concluir a operação', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const openModalByStatus = (status, policy) => {
    if (
      reactivationStatusEquals(status, REACTIVATION_STATUS.AWAITING_SIGN) ||
      reactivationStatusEquals(status, REACTIVATION_STATUS.AWAITING_TERM) ||
      reactivationStatusEquals(status, 'awaiting_sign_reactivation')
    ) {
      setOpenTermPanel(true);
    } else if (reactivationStatusEquals(status, REACTIVATION_STATUS.AWAITING_INSPECTION)) {
      setOpenInspectionPanel(true);
    } else if (
      reactivationStatusEquals(status, REACTIVATION_STATUS.AWAITING_ACCEPTANCE) ||
      reactivationStatusEquals(status, 'awaiting_acceptance_term_reactivation')
    ) {
      setOpenAcceptancePanel(true);
    } else if (isReactivationInspectApprovedStep(status)) {
      setOpenInspectApprovedPanel(true);
    } else if (
      reactivationStatusEquals(status, REACTIVATION_STATUS.AWAITING_PAID) ||
      reactivationStatusEquals(status, REACTIVATION_STATUS.AWAITING_PAYMENT_REACTIVATION)
    ) {
      setOpenReactivationPaymentPanel(true);
    } else {
      setOpenActionsPanel(true);
    }
  };

  const handleOpenActionsPanel = async (policy) => {
    setSelectedPolicy(policy);
    setLoadingCurrentReactivation(true);
    try {
      const resp = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.currentReactivation(policy.id),
        headers: { Authorization: Cookies.get('splitrisk-authtoken') },
      });

      const payload = resp?.data;
      const reactivation = Object.prototype.hasOwnProperty.call(payload || {}, 'reactivation') ? payload.reactivation : payload;
      setReactivationDetail(reactivation != null && typeof reactivation === 'object' ? reactivation : null);
      const fromApi = getReactivationCurrentStatus(reactivation);
      const listStatus = policy?.status_reativacao;
      const listActive = listStatus && !reactivationStatusEquals(listStatus, 'canceled');
      const flowStatus = fromApi || (listActive ? listStatus : null);

      if (!flowStatus || reactivationStatusEquals(flowStatus, 'canceled')) {
        setOpenActionsPanel(true);
      } else {
        openModalByStatus(flowStatus, policy);
      }
    } catch {
      setReactivationDetail(null);
      openModalByStatus(policy?.status_reativacao || 'canceled', policy);
    } finally {
      setLoadingCurrentReactivation(false);
    }
  };

  const handleCloseActionsPanel = () => {
    setOpenActionsPanel(false);
    setSelectedPolicy(null);
  };

  const handleStartReactivation = async () => {
    if (!selectedPolicy?.id) return;
    setLoadingAction(true);
    try {
      const response = await api({
        method: 'POST',
        url: REACTIVATION_ENDPOINTS.start(selectedPolicy.id),
        headers: { Authorization: Cookies.get('splitrisk-authtoken') },
      });
      toast.success('Reativação iniciada com sucesso!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });

      const nextStep = response?.data?.nextFlow;
      const updatedStatus = response?.data?.status || response?.data?.policy?.status;
      const rd = response?.data;
      const rFromStart = Object.prototype.hasOwnProperty.call(rd || {}, 'reactivation') ? rd.reactivation : rd;
      setReactivationDetail(rFromStart != null && typeof rFromStart === 'object' ? rFromStart : null);
      setOpenActionsPanel(false);

      if (
        nextStep === REACTIVATION_NEXT_STEP.TERM ||
        updatedStatus === REACTIVATION_STATUS.AWAITING_TERM ||
        updatedStatus === REACTIVATION_STATUS.AWAITING_SIGN
      ) {
        setOpenTermPanel(true);
      } else if (nextStep === REACTIVATION_NEXT_STEP.INSPECTION || updatedStatus === REACTIVATION_STATUS.AWAITING_INSPECTION) {
        setOpenInspectionPanel(true);
      } else if (isReactivationInspectApprovedStep(updatedStatus)) {
        setOpenInspectApprovedPanel(true);
      } else {
        setOpenTermPanel(true);
      }

      loadData({ silent: true });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível iniciar reativação', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const handleCloseTermPanel = () => {
    setOpenTermPanel(false);
    setSignedTermFile(null);
    setCnhFile(null);
  };

  const handleDownloadTerm = async () => {
    if (!selectedPolicy?.id) return;
    setLoadingAction(true);
    try {
      const response = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.downloadTerm(selectedPolicy.id),
        headers: { Authorization: Cookies.get('splitrisk-authtoken') },
        responseType: 'blob',
      });
      const contentDisposition = response?.headers?.['content-disposition'] || '';
      const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
      const filename = filenameMatch?.[1] || `termo_reativacao_${selectedPolicy.id}.docx`;
      const fileBlob = new Blob([response?.data], {
        type: response?.headers?.['content-type'] || 'application/octet-stream',
      });
      const url = window.URL.createObjectURL(fileBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível baixar termo', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const handleUploadDocuments = async () => {
    if (!selectedPolicy?.id || !signedTermFile || !cnhFile) return;
    setLoadingAction(true);
    try {
      const formData = new FormData();
      formData.append('signedTermFile', signedTermFile);
      formData.append('cnhFile', cnhFile);
      await api({
        method: 'POST',
        url: REACTIVATION_ENDPOINTS.uploadSignedTerm(selectedPolicy.id),
        headers: {
          Authorization: Cookies.get('splitrisk-authtoken'),
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      });
      toast.success('Documentos enviados com sucesso!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      handleCloseTermPanel();
      loadData();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível enviar documentos', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const handleCloseInspectionPanel = () => {
    setOpenInspectionPanel(false);
    setReactivationDetail(null);
    setInspectionEndpointLink('');
    setLoadingInspectionEndpointLink(false);
  };

  const refreshReactivationDetail = async (contractId) => {
    if (!contractId) return;
    try {
      const resp = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.currentReactivation(contractId),
        headers: { Authorization: Cookies.get('splitrisk-authtoken') },
      });
      const payload = resp?.data;
      const reactivation = Object.prototype.hasOwnProperty.call(payload || {}, 'reactivation') ? payload.reactivation : payload;
      setReactivationDetail(reactivation != null && typeof reactivation === 'object' ? reactivation : null);
    } catch {}
  };

  const handleCopyInspectionLink = async () => {
    const link = inspectionEndpointLink?.trim();
    if (!link) {
      toast.error('Nenhum link de vistoria disponível.', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      return;
    }
    try {
      await navigator.clipboard.writeText(link);
      toast.success('Link da vistoria copiado!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
    } catch {
      try {
        const ta = document.createElement('textarea');
        ta.value = link;
        ta.setAttribute('readonly', '');
        ta.style.position = 'absolute';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        toast.success('Link da vistoria copiado!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      } catch {
        toast.error('Não foi possível copiar o link.', {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
        });
      }
    }
  };

  const handleGenerateInspection = async () => {
    if (!selectedPolicy?.id) return;
    setLoadingAction(true);
    try {
      await api({
        method: 'POST',
        url: REACTIVATION_ENDPOINTS.requestReactivationInspection(selectedPolicy.id),
        headers: { Authorization: Cookies.get('splitrisk-authtoken') },
      });
      toast.success('Vistoria gerada com sucesso!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      const url = await fetchReactivationInspectionUrl(selectedPolicy.id);
      setInspectionEndpointLink(url);
      await refreshReactivationDetail(selectedPolicy.id);
      loadData({ silent: true });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível gerar vistoria', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const handleCloseAcceptancePanel = () => {
    setOpenAcceptancePanel(false);
    setSelectedPolicy(null);
  };

  const downloadBlobFromApi = async (url, fallbackFilename) => {
    const response = await api({
      method: 'GET',
      url,
      headers: { Authorization: Cookies.get('splitrisk-authtoken') },
      responseType: 'blob',
    });
    const contentDisposition = response?.headers?.['content-disposition'] || '';
    const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
    const filename = filenameMatch?.[1] || fallbackFilename;
    const fileBlob = new Blob([response?.data], {
      type: response?.headers?.['content-type'] || 'application/octet-stream',
    });
    const objectUrl = window.URL.createObjectURL(fileBlob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
  };

  const handleOpenReactivationSubscriptionInvoice = async () => {
    if (!selectedPolicy?.id) return;
    setLoadingAction(true);
    try {
      const resp = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.reactivationSubscriptionInvoice(selectedPolicy.id),
        headers: { Authorization: Cookies.get('splitrisk-authtoken') },
      });
      const invoiceUrl = resp?.data?.invoice_url ?? resp?.data?.invoiceUrl;
      if (!invoiceUrl) {
        toast.error('Link da fatura não foi retornado pela API.', {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
        });
        return;
      }
      window.open(invoiceUrl, '_blank', 'noopener,noreferrer');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível obter a fatura do boleto', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const handleDownloadUploadedSignedTerm = async () => {
    if (!selectedPolicy?.id) return;
    setLoadingAction(true);
    try {
      await downloadBlobFromApi(
        REACTIVATION_ENDPOINTS.downloadReactivationUploadedDocument(selectedPolicy.id, REACTIVATION_UPLOADED_DOCUMENT_TYPE.TERM),
        `termo_assinado_reativacao_${selectedPolicy.id}.pdf`,
      );
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível baixar o termo enviado', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const handleDownloadUploadedCnh = async () => {
    if (!selectedPolicy?.id) return;
    setLoadingAction(true);
    try {
      await downloadBlobFromApi(
        REACTIVATION_ENDPOINTS.downloadReactivationUploadedDocument(selectedPolicy.id, REACTIVATION_UPLOADED_DOCUMENT_TYPE.CNH),
        `cnh_reativacao_${selectedPolicy.id}.pdf`,
      );
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível baixar a CNH enviada', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const handleAcceptanceDecision = async (accepted) => {
    if (!selectedPolicy?.id) return;
    if (!accepted) {
      const ok = window.confirm(
        'Encerrar a reativação como não concluída? Essa ação confirma que os documentos não foram aceitos e finaliza o fluxo.',
      );
      if (!ok) return;
    }
    setLoadingAction(true);
    try {
      await api({
        method: 'POST',
        url: REACTIVATION_ENDPOINTS.confirmReactivation(selectedPolicy.id),
        headers: {
          Authorization: Cookies.get('splitrisk-authtoken'),
          'Content-Type': 'application/json',
        },
        data: { accepted },
      });
      if (accepted) {
        toast.success('Reativação aceita. A cobrança foi gerada.', {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
        });
        setOpenAcceptancePanel(false);
        setOpenReactivationPaymentPanel(true);
        loadData({ silent: true });
      } else {
        toast.success('Reativação encerrada como não concluída.', {
          position: toast.POSITION.TOP_RIGHT,
          theme: 'colored',
        });
        handleCloseAcceptancePanel();
        loadData({ silent: true });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível concluir a operação', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } finally {
      setLoadingAction(false);
    }
  };

  const handleOpenBilletsContract = () => {
    if (!selectedPolicy?.id) return;
    window.open(`/backoffice/faturas/${selectedPolicy.id}`, '_blank', 'noopener,noreferrer');
  };

  const handleCloseMovementsPanel = () => {
    setOpenMovementsPanel(false);
    setSelectedPolicyMovements(null);
    setReactivationHistory([]);
    setLoadingMovements(false);
  };

  const normalizeReactivationHistoryResponse = (payload) => {
    const root = payload?.reactivation ?? payload;
    if (!root) return [];
    return Array.isArray(root) ? root : [root];
  };

  const handleOpenMovementsPanel = async (policy, event) => {
    event?.stopPropagation?.();
    setSelectedPolicyMovements(policy);
    setOpenMovementsPanel(true);
    setLoadingMovements(true);
    setReactivationHistory([]);
    try {
      const resp = await api({
        method: 'GET',
        url: REACTIVATION_ENDPOINTS.currentReactivation(policy?.id),
        headers: {
          Authorization: Cookies.get('splitrisk-authtoken'),
          Accept: 'application/json',
        },
      });
      const history = normalizeReactivationHistoryResponse(resp?.data);
      setReactivationHistory(history);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Não foi possível carregar o histórico da reativação', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
      const fallback = normalizeMovements(policy?.logs);
      setReactivationHistory(fallback.length ? [{ logs: fallback }] : []);
    } finally {
      setLoadingMovements(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const columnsWithActions = [
    ...dataColumns,
    {
      name: 'Histórico',
      cell: (row) => (
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <button
            type="button"
            onClick={(event) => handleOpenMovementsPanel(row, event)}
            title="Ver movimentações da reativação"
            style={{
              background: 'transparent',
              border: 'none',
              color: primary,
              fontWeight: 700,
              cursor: 'pointer',
              padding: 0,
              textDecoration: 'underline',
            }}
          >
            Ver
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '95px',
      minWidth: '95px',
      maxWidth: '95px',
      grow: 0,
    },
  ];

  const renderActionsDialog = () => (
    <Dialog open={openActionsPanel} onClose={handleCloseActionsPanel} width="480px" title="Iniciar Reativação">
      {selectedPolicy && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <PolicyInfoCard policy={selectedPolicy} />

          <div style={{ textAlign: 'center', padding: '8px 0' }}>
            <BsArrowClockwise size={32} color={primary} style={{ marginBottom: 8 }} />
            <p style={{ margin: 0, fontSize: 14, color: middleGray }}>
              Ao iniciar, o sistema determinará automaticamente a próxima etapa da reativação.
            </p>
          </div>

          <ModalButton style={{ justifyContent: 'center' }}>
            <Button height="38px" onClick={handleStartReactivation} disabled={loadingAction}>
              {loadingAction ? <ReactLoading color={white} height={20} width={20} type="spin" /> : 'Iniciar Reativação'}
            </Button>
          </ModalButton>
        </div>
      )}
    </Dialog>
  );

  const renderTermDialog = () => (
    <Dialog open={openTermPanel} onClose={handleCloseTermPanel} width="520px" title="Documentação de Reativação">
      {selectedPolicy && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <PolicyInfoCard policy={selectedPolicy} />

          <div style={{ background: '#f0f7ff', border: '1px solid #cce0ff', borderRadius: 8, padding: 14 }}>
            <p style={{ margin: 0, fontSize: 13, color: '#1a5276', fontWeight: 600 }}>Passo 1: Baixe o termo de reativação</p>
            <p style={{ margin: '6px 0 0', fontSize: 12, color: '#2c6e99' }}>
              Imprima, colete a assinatura do cliente e digitalize o documento.
            </p>
            <div style={{ marginTop: 10 }}>
              <Button height="32px" outlined onClick={handleDownloadTerm} disabled={loadingAction}>
                <BsDownload size={14} style={{ marginRight: 6 }} />
                {loadingAction ? <ReactLoading color={primary} height={18} width={18} type="spin" /> : 'Baixar Termo'}
              </Button>
            </div>
          </div>

          <div style={{ background: '#fafafa', border: `1px solid ${lightGray}`, borderRadius: 8, padding: 14 }}>
            <p style={{ margin: '0 0 10px', fontSize: 13, color: '#1a5276', fontWeight: 600 }}>Passo 2: Envie os documentos</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ background: white, border: `1px solid ${lightGray}`, borderRadius: 6, padding: 12 }}>
                <UploadFileInput
                  label="Termo assinado"
                  text="Termo assinado"
                  acceptedExtensions={['.pdf']}
                  onFileSelect={(file) => setSignedTermFile(file)}
                  onFileRemove={() => setSignedTermFile(null)}
                  buttonColor={secondary}
                  width="50%"
                  style={{ margin: 0 }}
                />
              </div>

              <div style={{ background: white, border: `1px solid ${lightGray}`, borderRadius: 6, padding: 12 }}>
                <UploadFileInput
                  label="CNH"
                  text="Selecionar CNH"
                  acceptedExtensions={['.pdf']}
                  onFileSelect={(file) => setCnhFile(file)}
                  onFileRemove={() => setCnhFile(null)}
                  buttonColor={secondary}
                  width="50%"
                  style={{ margin: 0 }}
                />
              </div>
            </div>
          </div>

          <ModalButton style={{ justifyContent: 'center', marginTop: 4 }}>
            <Button height="38px" onClick={handleUploadDocuments} disabled={loadingAction || !signedTermFile || !cnhFile}>
              <BsUpload size={14} style={{ marginRight: 6 }} />
              {loadingAction ? <ReactLoading color={white} height={20} width={20} type="spin" /> : 'Enviar Documentos'}
            </Button>
          </ModalButton>
        </div>
      )}
    </Dialog>
  );

  const renderAcceptanceDialog = () => (
    <Dialog open={openAcceptancePanel} onClose={handleCloseAcceptancePanel} width="520px" title="Aceitação da reativação">
      {selectedPolicy && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <PolicyInfoCard policy={selectedPolicy} />

          <div style={{ background: '#f8f9fa', border: `1px solid ${lightGray}`, borderRadius: 8, padding: 14 }}>
            <p style={{ margin: '0 0 10px', fontSize: 13, color: '#333', fontWeight: 600 }}>Documentos enviados</p>
            <p style={{ margin: '0 0 12px', fontSize: 12, color: middleGray }}>
              Baixe o termo assinado e a CNH recebidos para conferência antes de decidir.
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
              <Button height="32px" outlined onClick={handleDownloadUploadedSignedTerm} disabled={loadingAction}>
                <BsDownload size={14} style={{ marginRight: 6 }} />
                Baixar termo enviado
              </Button>
              <Button height="32px" outlined onClick={handleDownloadUploadedCnh} disabled={loadingAction}>
                <BsDownload size={14} style={{ marginRight: 6 }} />
                Baixar CNH enviada
              </Button>
            </div>
          </div>

          <div style={{ background: '#fff8e6', border: '1px solid #f5e6b3', borderRadius: 8, padding: 14 }}>
            <p style={{ margin: '0 0 12px', fontSize: 13, color: '#6c5a00', fontWeight: 600 }}>Decisão</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
              <Button
                height="38px"
                onClick={() => handleAcceptanceDecision(true)}
                disabled={loadingAction}
                style={{ minWidth: 200 }}
              >
                {loadingAction ? (
                  <ReactLoading color={white} height={20} width={20} type="spin" />
                ) : (
                  <>
                    <BsCheck2Circle size={16} style={{ marginRight: 8 }} />
                    Concluir reativação
                  </>
                )}
              </Button>
              <Button height="38px" outlined onClick={() => handleAcceptanceDecision(false)} disabled={loadingAction}>
                <BsXCircle size={16} style={{ marginRight: 8 }} />
                Não concluir reativação
              </Button>
            </div>
          </div>

          <ModalButton style={{ justifyContent: 'center' }}>
            <Button height="34px" outlined onClick={handleCloseAcceptancePanel}>
              Fechar
            </Button>
          </ModalButton>
        </div>
      )}
    </Dialog>
  );

  const renderReactivationPaymentDialog = () => (
    <Dialog
      open={openReactivationPaymentPanel}
      onClose={handleCloseReactivationPaymentPanel}
      width="480px"
      title="Boleto da reativação"
    >
      {selectedPolicy && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <PolicyInfoCard policy={selectedPolicy} />
          <div style={{ background: '#e8f4fc', border: '1px solid #b8d4eb', borderRadius: 8, padding: 14 }}>
            <p style={{ margin: 0, fontSize: 13, color: '#1a5276', lineHeight: 1.5 }}>
              Baixe o PDF do boleto da reativação. Na tela de boletos do contrato você também pode acompanhar o status do
              pagamento.
            </p>
          </div>
          <ModalButton style={{ justifyContent: 'center', display: 'flex', flexWrap: 'wrap', gap: 10 }}>
            <Button height="38px" outlined onClick={handleOpenReactivationSubscriptionInvoice} disabled={loadingAction}>
              <BsDownload size={14} style={{ marginRight: 6 }} />
              {loadingAction ? <ReactLoading color={primary} height={18} width={18} type="spin" /> : 'Visualizar cobrança'}
            </Button>
            <Button height="38px" onClick={handleOpenBilletsContract}>
              <BsReceipt size={16} style={{ marginRight: 8 }} />
              Faturas do contrato
            </Button>
          </ModalButton>
          <ModalButton style={{ justifyContent: 'center' }}>
            <Button height="34px" outlined onClick={handleCloseReactivationPaymentPanel}>
              Fechar
            </Button>
          </ModalButton>
        </div>
      )}
    </Dialog>
  );

  const renderInspectApprovedDialog = () => {
    const inspectionCode = getReactivationInspectionDisplayCode(reactivationDetail);
    const link = getInspectApprovedEffectiveLink();
    const statusFromDetail = getReactivationCurrentStatus(reactivationDetail);
    const isApprovedWithNotes =
      reactivationStatusEquals(statusFromDetail, REACTIVATION_STATUS.INSPECT_APPROVED_WITH_NOTES) ||
      reactivationStatusEquals(selectedPolicy?.status_reativacao, REACTIVATION_STATUS.INSPECT_APPROVED_WITH_NOTES);

    const approvedHeadline = (() => {
      if (isApprovedWithNotes) {
        return inspectionCode
          ? `A vistoria ${inspectionCode} foi aprovada com observações.`
          : 'A vistoria foi aprovada com observações.';
      }
      return inspectionCode ? `A vistoria ${inspectionCode} foi aprovada.` : 'A vistoria foi aprovada.';
    })();

    return (
      <Dialog
        open={openInspectApprovedPanel}
        onClose={handleCloseInspectApprovedPanel}
        width="520px"
        title={isApprovedWithNotes ? 'Vistoria aprovada com observações' : 'Vistoria aprovada'}
      >
        {selectedPolicy && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <PolicyInfoCard policy={selectedPolicy} />

            <div style={{ background: '#e8f8f0', border: '1px solid #a9dfbf', borderRadius: 8, padding: 14 }}>
              <p style={{ margin: '0 0 8px', fontSize: 14, color: '#1e8449', fontWeight: 600, lineHeight: 1.45 }}>
                {approvedHeadline}
              </p>
              <p style={{ margin: '0 0 12px', fontSize: 12, color: '#566573', lineHeight: 1.5 }}>
                Confirme para seguir com a geração do boleto da reativação ou cancele para encerrar o fluxo.
              </p>

              <p style={{ margin: '0 0 8px', fontSize: 13, color: '#1e8449', fontWeight: 600 }}>Link da vistoria</p>
              {loadingInspectApprovedUrl ? (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0' }}>
                  <ReactLoading color={primary} height={28} width={28} type="spin" />
                </div>
              ) : null}
              {!loadingInspectApprovedUrl && link ? (
                <>
                  <p
                    style={{
                      margin: '0 0 12px',
                      fontSize: 12,
                      color: '#333',
                      wordBreak: 'break-all',
                      lineHeight: 1.45,
                      fontFamily: 'monospace',
                    }}
                  >
                    {link}
                  </p>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button height="36px" outlined onClick={handleCopyInspectApprovedLink} disabled={loadingAction}>
                      <BsClipboard size={15} style={{ marginRight: 8 }} />
                      Copiar link
                    </Button>
                  </div>
                </>
              ) : null}
              {!loadingInspectApprovedUrl && !link ? (
                <p style={{ margin: 0, fontSize: 12, color: '#566573' }}>
                  Link não disponível no momento. Você ainda pode confirmar ou cancelar abaixo.
                </p>
              ) : null}
            </div>

            <div style={{ background: '#fff8e6', border: '1px solid #f5e6b3', borderRadius: 8, padding: 14 }}>
              <p style={{ margin: '0 0 12px', fontSize: 13, color: '#6c5a00', fontWeight: 600 }}>Decisão</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
                <Button
                  height="38px"
                  onClick={() => handleInspectApprovedDecision(true)}
                  disabled={loadingAction}
                  style={{ minWidth: 180 }}
                >
                  {loadingAction ? (
                    <ReactLoading color={white} height={20} width={20} type="spin" />
                  ) : (
                    <>
                      <BsCheck2Circle size={16} style={{ marginRight: 8 }} />
                      Confirmar
                    </>
                  )}
                </Button>
                <Button height="38px" outlined onClick={() => handleInspectApprovedDecision(false)} disabled={loadingAction}>
                  <BsXCircle size={16} style={{ marginRight: 8 }} />
                  Cancelar
                </Button>
              </div>
            </div>

            <ModalButton style={{ justifyContent: 'center' }}>
              <Button height="34px" outlined onClick={handleCloseInspectApprovedPanel}>
                Fechar
              </Button>
            </ModalButton>
          </div>
        )}
      </Dialog>
    );
  };

  const renderInspectionDialog = () => {
    const inspectionLink = inspectionEndpointLink?.trim() || '';
    const statusFromDetail = getReactivationCurrentStatus(reactivationDetail);
    const isAwaitingInspection =
      reactivationStatusEquals(statusFromDetail, REACTIVATION_STATUS.AWAITING_INSPECTION) ||
      reactivationStatusEquals(selectedPolicy?.status_reativacao, REACTIVATION_STATUS.AWAITING_INSPECTION);
    const showInspectionLinkBlock = isAwaitingInspection || loadingInspectionEndpointLink || Boolean(inspectionLink);
    const inspectionAlreadyGenerated = Boolean(inspectionLink);
    const disableGenerateInspection = loadingAction || loadingInspectionEndpointLink || inspectionAlreadyGenerated;

    return (
      <Dialog
        open={openInspectionPanel}
        onClose={handleCloseInspectionPanel}
        width="520px"
        title={isAwaitingInspection ? 'Aguardando vistoria' : 'Nova vistoria'}
      >
        {selectedPolicy && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            <PolicyInfoCard policy={selectedPolicy} />

            {showInspectionLinkBlock && (
              <div
                style={{
                  background: '#e8f8f0',
                  border: '1px solid #a9dfbf',
                  borderRadius: 8,
                  padding: 14,
                }}
              >
                <p style={{ margin: '0 0 10px', fontSize: 13, color: '#1e8449', fontWeight: 600 }}>Link da vistoria</p>
                {loadingInspectionEndpointLink ? (
                  <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0' }}>
                    <ReactLoading color={primary} height={28} width={28} type="spin" />
                  </div>
                ) : null}
                {!loadingInspectionEndpointLink && inspectionLink ? (
                  <>
                    <p
                      style={{
                        margin: '0 0 12px',
                        fontSize: 12,
                        color: '#333',
                        wordBreak: 'break-all',
                        lineHeight: 1.45,
                        fontFamily: 'monospace',
                      }}
                    >
                      {inspectionLink}
                    </p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
                      <Button height="38px" onClick={handleCopyInspectionLink} disabled={loadingAction}>
                        <BsClipboard size={15} style={{ marginRight: 8 }} />
                        Copiar link
                      </Button>
                    </div>
                  </>
                ) : null}
                {!loadingInspectionEndpointLink && !inspectionLink ? (
                  <p style={{ margin: 0, fontSize: 12, color: '#566573', lineHeight: 1.5 }}>
                    O link ainda não está disponível neste contrato. Gere a vistoria abaixo (a geração é feita uma única vez).
                  </p>
                ) : null}
              </div>
            )}

            <div
              style={{ background: '#fef9e7', border: '1px solid #f9e79f', borderRadius: 8, padding: 14, textAlign: 'center' }}
            >
              <p style={{ margin: 0, fontSize: 14, color: '#7d6608', fontWeight: 600 }}>
                {inspectionAlreadyGenerated
                  ? 'Vistoria já gerada'
                  : isAwaitingInspection
                    ? 'Gerar vistoria'
                    : 'Este contrato requer uma nova vistoria'}
              </p>
              <p style={{ margin: '6px 0 0', fontSize: 12, color: '#9a7d0a' }}>
                {inspectionAlreadyGenerated
                  ? 'A vistoria só pode ser gerada uma vez. Use o link acima para o cliente concluir a vistoria.'
                  : isAwaitingInspection
                    ? 'Após gerar, o link aparecerá acima para copiar. Não é possível gerar outra vistoria para o mesmo fluxo.'
                    : 'Uma nova vistoria será gerada e enviada ao cliente para prosseguir com a reativação.'}
              </p>
            </div>

            <ModalButton style={{ justifyContent: 'center', display: 'flex', flexWrap: 'wrap', gap: 10 }}>
              <Button height="38px" onClick={handleGenerateInspection} disabled={disableGenerateInspection}>
                {loadingAction ? <ReactLoading color={white} height={20} width={20} type="spin" /> : 'Gerar nova vistoria'}
              </Button>
              <Button height="34px" outlined onClick={handleCloseInspectionPanel}>
                Fechar
              </Button>
            </ModalButton>
          </div>
        )}
      </Dialog>
    );
  };

  const renderMovementsDialog = () => (
    <Dialog
      open={openMovementsPanel}
      onClose={handleCloseMovementsPanel}
      width="560px"
      title={`Histórico de Reativação - ${selectedPolicyMovements?.contrato || selectedPolicyMovements?.id || ''}`}
    >
      {loadingMovements && (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '18px 0' }}>
          <ReactLoading color={primary} height={28} width={28} type="spin" />
        </div>
      )}

      {!loadingMovements && !reactivationHistory.length && (
        <p style={{ margin: '20px 0', color: middleGray, textAlign: 'center', fontSize: 14 }}>
          Nenhum histórico de reativação encontrado.
        </p>
      )}

      {!loadingMovements && reactivationHistory.length > 0 && (
        <div style={{ padding: '8px 0', display: 'flex', flexDirection: 'column', gap: 12 }}>
          {reactivationHistory.map((reactivationItem, idx) => {
            const status = getReactivationCurrentStatus(reactivationItem) || reactivationItem?.status;
            const statusInfo = formatPolicyReactivationStatus(status);

            const createdAt = reactivationItem?.created_at;
            const completedAt = reactivationItem?.completed_at;
            const movements = normalizeMovements(reactivationItem?.logs);

            const getInspectionCodeFromMovements = () => {
              for (let i = movements.length - 1; i >= 0; i -= 1) {
                const c = movements[i]?.inspection_code ?? movements[i]?.inspectionCode;
                if (c != null && String(c).trim()) return String(c).trim();
              }
              return '';
            };

            const inspectionCode = getInspectionCodeFromMovements();

            const headerTitle = statusInfo?.label || status || `Reativação #${idx + 1}`;

            return (
              <div
                key={reactivationItem?.id || `${selectedPolicyMovements?.id || 'policy'}-react-${idx}`}
                style={{
                  border: `1px solid ${lightGray}`,
                  borderRadius: 10,
                  padding: 12,
                  background: '#fafafa',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                  <div
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      background: statusInfo?.color || primary,
                      marginTop: 6,
                      flexShrink: 0,
                    }}
                  />
                  <div style={{ flex: 1 }}>
                    <p style={{ margin: 0, fontWeight: 800, fontSize: 13, color: '#333' }}>{headerTitle}</p>
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '6px 14px',
                        marginTop: 6,
                        color: middleGray,
                        fontSize: 11,
                      }}
                    >
                      {reactivationItem?.reactivation_code ? (
                        <span>
                          Código:{' '}
                          <strong style={{ color: '#333', fontFamily: 'monospace' }}>{reactivationItem.reactivation_code}</strong>
                        </span>
                      ) : null}
                      {createdAt ? (
                        <span>
                          Início: <strong style={{ color: '#333' }}>{moment.utc(createdAt).format('DD/MM/YYYY HH:mm')}</strong>
                        </span>
                      ) : null}
                      {completedAt ? (
                        <span>
                          Conclusão:{' '}
                          <strong style={{ color: '#333' }}>{moment.utc(completedAt).format('DD/MM/YYYY HH:mm')}</strong>
                        </span>
                      ) : null}
                      {inspectionCode ? (
                        <span>
                          Vistoria: <strong style={{ color: '#333' }}>{inspectionCode}</strong>
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: 10 }}>
                  {!movements.length ? (
                    <p style={{ margin: 0, color: middleGray, fontSize: 12, textAlign: 'center' }}>
                      Sem movimentações nesta reativação.
                    </p>
                  ) : (
                    <div style={{ background: white, border: `1px solid ${lightGray}`, borderRadius: 8, padding: 8 }}>
                      {[...movements]
                        .sort((a, b) => getMovementDateValue(b) - getMovementDateValue(a))
                        .map((movement, index) => (
                          <div
                            key={`${movement?.id || 'mov'}-${index}`}
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: 10,
                              padding: '8px 0',
                              borderBottom: index < movements.length - 1 ? `1px solid ${lightGray}` : 'none',
                            }}
                          >
                            <div style={{ flex: 1 }}>
                              <p style={{ margin: 0, fontWeight: 700, fontSize: 12, color: '#333' }}>
                                {getStatusLabel(movement?.status)}
                              </p>
                            </div>
                            <small style={{ color: middleGray, whiteSpace: 'nowrap', fontSize: 11 }}>
                              {moment
                                .utc(movement?.data_criacao || movement?.created_at || movement?.date || movement?.updated_at)
                                .format('DD/MM/YYYY HH:mm')}
                            </small>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Dialog>
  );

  return (
    <>
      <Header />
      <Container>
        {renderActionsDialog()}
        {renderTermDialog()}
        {renderInspectionDialog()}
        {renderAcceptanceDialog()}
        {renderReactivationPaymentDialog()}
        {renderInspectApprovedDialog()}
        {renderMovementsDialog()}
        <SideMenu />

        <ContentArea>
          <Div>
            <Title>REATIVAÇÃO</Title>
            <div className="containerTitle">
              <Button title="Exportar" height="30px" onClick={handleExport} disabled={loadingExport}>
                {loadingExport ? (
                  <ReactLoading color={white} height={25} width={25} type="spin" />
                ) : (
                  <RiFileExcel2Fill size={18} />
                )}
              </Button>
              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData();
                }}
                onConfirm={loadData}
              />
            </div>
          </Div>

          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={handleLoadMore}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={10}
            >
              <DataTable
                onRowClicked={(row) => !loadingCurrentReactivation && handleOpenActionsPanel(row)}
                persistTableHead
                responsive
                columns={columnsWithActions}
                data={policiesList}
                highlightOnHover
                pointerOnHover={!loadingCurrentReactivation}
                fixedHeader
                fixedHeaderScrollHeight="100%"
                progressPending={loading || loadingCurrentReactivation}
                progressComponent={
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                }
                noDataComponent={<small style={{ marginTop: 20 }}>Nenhum contrato elegível para reativação</small>}
              />
            </InfiniteScroll>
          </DataArea>

          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}
            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {policiesList?.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default ReactivationList;
